
// Usamos un Set global para mantener los badges ya notificados en esta sesión
const sessionNotifiedBadges = new Set<string>();

export const markBadgeAsNotified = (userId: string, badgeType: string): void => {
  const badgeKey = `${userId}:${badgeType}`;
  sessionNotifiedBadges.add(badgeKey);
};

export const isBadgeAlreadyNotified = (userId: string, badgeType: string): boolean => {
  const badgeKey = `${userId}:${badgeType}`;
  return sessionNotifiedBadges.has(badgeKey);
};

export const clearSessionNotifications = (): void => {
  sessionNotifiedBadges.clear();
};
